import "./CustomTopBar.scss"

import { Layout as MenuLayout } from "@/layouts"

// 顶部菜单栏
export default function CustomTopBar() {
  return (
    <div
      className="topBarContainer"
      style={{
        "--p-surface-primary-selected-pressed": "#999EA4",
        "--p-action-primary": "#008060",
        "--p-space-200": "16px"
      }}
    >
      <MenuLayout />
    </div>
  )
}
